import { render, staticRenderFns } from "./input-multilang-head.vue?vue&type=template&id=bcdab7ac&"
import script from "./input-multilang-head.vue?vue&type=script&lang=js&"
export * from "./input-multilang-head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports